import './category-dropdown.common';
import { wioPopoutMenu } from './category-dropdown.common';

wioPopoutMenu('.js-popout-menu-sort', '.js-wio__sortables');
